export const hasPageAccess = (pathName: string) => {
  const stringifyScopes: string | null = window.localStorage.getItem('SCOPES');
  const scopes = stringifyScopes && JSON.parse(stringifyScopes);

  if (!scopes) return false;

  const path = pathName.split('/')[1].replaceAll('-', '');

  const isPageOnScopes = !!scopes.find((s: any) => s.path === path);

  return isPageOnScopes;
};
